var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGrid3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 15,
    viewBox: "0 0 22 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 6.84C16.66 6.84 17.99 5.5 17.99 3.84C17.99 2.18 16.66 0.839996 15 0.839996C13.34 0.839996 12 2.18 12 3.84C12 5.5 13.34 6.84 15 6.84ZM7 6.84C8.66 6.84 9.99 5.5 9.99 3.84C9.99 2.18 8.66 0.839996 7 0.839996C5.34 0.839996 4 2.18 4 3.84C4 5.5 5.34 6.84 7 6.84ZM7 8.84C4.67 8.84 0 10.01 0 12.34V14.84H14V12.34C14 10.01 9.33 8.84 7 8.84ZM15 8.84C14.71 8.84 14.38 8.86 14.03 8.89C15.19 9.73 16 10.86 16 12.34V14.84H22V12.34C22 10.01 17.33 8.84 15 8.84Z",
    fill: "white",
    fillOpacity: 0.8
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrid3);
export default __webpack_public_path__ + "static/media/grid3.9ebafff9122b46c883784548bc7ab64e.svg";
export { ForwardRef as ReactComponent };